import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

export const DIALOG_TYPE = 'CANCEL_TRANSACTION_RULE_DIALOG';

export const cancelTransactionRuleDialog = createAction(
  rootUiActions.createDialog.toString(),
  ({ onCancel }: { onCancel: () => void }) =>
    rootUiTypes.mkRootUiData({
      id: 'cancel-transaction-rule-dialog',
      type: DIALOG_TYPE,
      allowNesting: true,
      props: ImmutableMap({ onCancel }),
    }),
);
